module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'cl9s8snr',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
